import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

// Tooltip do B3612 (Cruzamento de Médias BIAS) — painel próprio, B36 + B612.
// yAccessor(d) retorna { b36, b612 }.
class B3612Tooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const d = isDefined(currentItem) && yAccessor(currentItem);
    const b36 = d && d.b36 !== undefined ? displayFormat(d.b36) : "n/a";
    const b612 = d && d.b612 !== undefined ? displayFormat(d.b612) : "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    if (shouldHideField(b36) && shouldHideField(b612)) return null;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-b3612"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{"B3612: "}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{`${b36}, ${b612}`}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

B3612Tooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

B3612Tooltip.defaultProps = {
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default B3612Tooltip;
